import React from 'react';
import './styles.css';
import Header from '../../../components/Header/Header';
import LeagueCard from '../../../components/LeagueCard/LeagueCard';
import BulletHeader from '../../../components/BulletHeader/BulletHeader';
import MBIcon from "../../../assets/images/mb_icon.svg";
import {Button, Col, Container, Row} from 'react-bootstrap';
import {prepareCheckout, getRegistrationDetails, getTournamentRegistrationDetails, getDiscount} from '../../../services/registrations';
import ScaleLoader from "react-spinners/ScaleLoader";
import {NotificationManager} from "react-notifications";
import history from "../../../history";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {withRouter} from "react-router-dom";
import {withTranslation} from "react-i18next";

const MySwal = withReactContent(Swal);

const override = `
    display: block;
    text-align: center;
    margin-top: 10%;
`;

class Payment extends React.Component {
   constructor(props) {
      super(props);

      this.state = {
         registrationDetails: {},
         discountInfo: {},
         costPerPlayer: undefined,
         registrationCost: undefined,
         loading: true
      };
   }

   async componentDidMount() {
      let registrationDetails;
      let discountInfo = await getDiscount(this.props.match.params.registrationId, history.location.state.isLeague)

      if (history.location.state.isLeague) {
         registrationDetails = await getRegistrationDetails(this.props.match.params.registrationId);
      } else {
         registrationDetails = await getTournamentRegistrationDetails(this.props.match.params.registrationId);
      }

      let playersCount = registrationDetails.second_player_name ? 2 : 1;
      let costPerPlayer = discountInfo.original_price / playersCount;
      let registrationCost = discountInfo.price_after_discount;

      let preparedCheckout = await prepareCheckout(this.props.match.params.registrationId, registrationCost, history.location.state.isLeague);

      this.setState({registrationDetails, discountInfo, costPerPlayer, registrationCost, loading: false});

      this.loadPaymentScript(preparedCheckout.id, history);
   }

   render() {
      const { t } = this.props;
      const hasPartner = !!this.state.registrationDetails.second_player_name;

      return (
         <div>
            <Header headerBarTitle={t("registration_page.header")} showHeaderExtras={true}>
               <h1>{t("registration_page.payment")}</h1>
            </Header>
            <ScaleLoader
               css={override}
               sizeUnit={"px"}
               size={30}
               color={'#afff55'}
               loading={this.state.loading}
            />
            {!this.state.loading &&
            <Container>
               <Row className={'toplabel'}>
                  <Col xs={12}>
                     <BulletHeader text={t("registration_page.registration_summary")}/>
                  </Col>
               </Row>
               <Row className={'mt-3'}>
                  <Col xs={12}>
                     <Row>
                        <Col xs={12}>
                           <LeagueCard
                              leagueNameClasses="card-games pb-3 mb-3"
                              leagueDate={history.location.state.isLeague ? this.state.registrationDetails.league_category : this.state.registrationDetails.category_name}
                              leagueName={history.location.state.isLeague ? `${this.state.registrationDetails.league}, ${this.state.registrationDetails.league_edition}` : this.state.registrationDetails.tournament_name}
                           >
                              <p className="start-date-container start-date-text">
                                 {hasPartner
                                    ? `${this.state.registrationDetails.first_player_name} ${t("to_schedule_page.and")} ${this.state.registrationDetails.second_player_name}`
                                    : this.state.registrationDetails.first_player_name}
                              </p>
                           </LeagueCard>
                        </Col>
                        <Col xs={12}>
                           <Row className={'pb-2 registration-pricing'}>
                              <Col xs={10}>
                                 <p>{this.state.registrationDetails.first_player_name}</p>
                              </Col>
                              <Col xs={2} className={'text-right'}>
                                 <p>{`${this.truncateByDecimalPlace(this.state.costPerPlayer, 2)} €`}</p>
                              </Col>
                           </Row>
                           {hasPartner &&
                              <Row className={"registration-pricing"}>
                                 <Col xs={10}>
                                    <p>{this.state.registrationDetails.second_player_name}</p>
                                 </Col>
                                 <Col xs={2} className={'text-right valor'}>
                                    <p>{`${this.truncateByDecimalPlace(this.state.costPerPlayer, 2)} €`}</p>
                                 </Col>
                                 <Col xs={12}>
                                    <hr/>
                                 </Col>
                              </Row>
                           }
                           {this.state.discountInfo.players_with_discount && this.state.discountInfo.players_with_discount.map((player, index) => {
                              return <Row key={index} className={"registration-pricing"}>
                                 <Col xs={10} className={"text-uppercase"}>
                                    <p className={"registration-pricing bold"}>{`${t("registration_page.payment_discount")} | `}<span>{player}</span></p>
                                 </Col>
                                 <Col xs={2} className={'text-right bold'}>
                                    {this.state.discountInfo.players_with_discount.length > 1 ?
                                       <p>{`-${this.truncateByDecimalPlace(this.state.discountInfo.discount / 2, 2)} €`}</p>
                                       :
                                       <p>{`-${this.truncateByDecimalPlace(this.state.discountInfo.discount, 2)} €`}</p>
                                    }
                                 </Col>
                              </Row>
                           })}
                           <Row>
                              <Col xs={12}>
                                 <hr/>
                              </Col>
                           </Row>
                           <Row>
                              <Col xs={10}>
                                 <p className={"registration-total"}>
                                    <b>{t("registration_page.payment_total")}</b>
                                 </p>
                              </Col>
                              <Col xs={2} className={'text-right'}>
                                 <p className={"registration-total"}>
                                    <b>{`${this.truncateByDecimalPlace(this.state.registrationCost, 2)} €`}</b>
                                 </p>
                              </Col>
                           </Row>
                        </Col>
                     </Row>
                  </Col>

                  <Col xs={12} className={"mt-3"}>
                     <Row>
                        <Col>
                           <form
                              action={`${process.env.REACT_APP_HOME}/enrollment/${this.props.match.params.registrationId}/payment_summary?is_league=${history.location.state.isLeague}`}
                              className={'paymentWidgets'}
                              data-brands={"MBWAY"}/>

                           <form
                              action={`${process.env.REACT_APP_HOME}/enrollment/${this.props.match.params.registrationId}/payment_summary?is_league=${history.location.state.isLeague}`}
                              className={'paymentWidgets'}
                              data-brands={"SIBS_MULTIBANCO"}/>
                        </Col>
                     </Row>
                     <Row className={"mb-3 mt-3"}>
                        <Col className={"text-center"}>
                           <Button className={"no-mbway"} onClick={() => this.openMBPopup()}>{t("registration_page.payment_no_mbway")}</Button>
                        </Col>
                     </Row>
                  </Col>
               </Row>
            </Container>
            }
         </div>
      );
   }

   openMBPopup = async () => {
      const { t } = this.props;

      MySwal.fire({
         allowOutsideClick: false,
         showCancelButton: true,
         titleText: t("registration_page.payment_no_mbway2"),
         html: `<img src='${MBIcon}' height="80px"/>`,
         confirmButtonText: t("registration_page.pay_with_mb"),
         cancelButtonText: t("common.cancel")
      }).then((res) => {

         if (res.dismiss === MySwal.DismissReason.cancel) {
            MySwal.close();
         } else {
            let formMB = document.getElementsByClassName("wpwl-form wpwl-form-prepayment wpwl-form-prepayment-SIBS_MULTIBANCO wpwl-clearfix")[0];
            formMB.submit();
         }
      });
   }

   loadPaymentScript = (checkoutId, history) => {
      const { t } = this.props;

      window.wpwlOptions = {
         locale: 'pt',
         style: 'card',
         showLabels: false,
         onReady: function(){
            let payNowButton = document.getElementsByClassName("wpwl-button wpwl-button-pay")[0];
            payNowButton.textContent = t("registration_page.pay_now")
            let phoneNumberInput = document.getElementsByClassName("wpwl-control wpwl-control-mobilePhone")[0];
            phoneNumberInput.placeholder = t("registration_page.mbway_phone_number");
         },
         onError: function(error){
            // Checkout expirou
            if (error.name === "InvalidCheckoutIdError") {
               MySwal.fire({
                  allowOutsideClick: false,
                  showCancelButton: true,
                  titleText: t("registration_page.session_expired_popup.title"),
                  text: t("registration_page.session_expired_popup.content"),
                  confirmButtonText: t("common.try_again"),
                  cancelButtonText: t("common.cancel")
               }).then((res) => {
                  if (res.dismiss === MySwal.DismissReason.cancel) {
                     history.push("/enrollment/list");
                  } else {
                     history.go(0);
                  }
               });
            }
         },
         validateVirtualAccount: function(){
            let phoneNumber = document.getElementsByClassName("wpwl-control wpwl-control-mobilePhone")[0].value.trim();

            if (phoneNumber === "") {
               NotificationManager.error(t("registration_page.errors.phone_mandatory"), t("common.error"), 4000);
               return false;
            } else {
               if (phoneNumber.match(/^9[1236]\d{7}$/) === null) {
                  NotificationManager.error(t("common.form.errors.special_characters"), t("common.error"), 4000);
                  return false;
               }
            }
         }
      };

      let scriptPaymentWidget = document.createElement('script');

      scriptPaymentWidget.src = process.env.REACT_APP_DPG_FORM_URL + checkoutId;

      document.body.appendChild(scriptPaymentWidget);
   };

   truncateByDecimalPlace = (value, numDecimalPlaces) =>
      Math.trunc(value * Math.pow(10, numDecimalPlaces)) / Math.pow(10, numDecimalPlaces)
}

export default withTranslation()(withRouter(Payment));


